import { useMemo } from 'react'
import { useFeatures } from './useFeatures'
import { GraphQL } from '@guestgoodie/graphql'

export function useIsPmsConnected() {
  const features = useFeatures()

  return useMemo(() => {
    return features?.some(
      f => f.type === GraphQL.IntegrationTypes.Pms && f.isSetupDone
    )
  }, [features])
}
